import { useTranslation } from "react-i18next";
import magazines from "../../data/magazines.json";
import Card from "../cards/ImgTextCard";

const Magazines = ({ renderBody }) => {
  const { t, i18n } = useTranslation();
  const isEnglish = (i18n.language || "it").startsWith("en");

  return (
    <div className="container subpage-container">
      <div className="text-center mb-5">
        <h2 className="subpage-title">
          {t("magazines.magazines")}
        </h2>
        <p className="text-muted max-w-700 mx-auto mt-2">
          {isEnglish
            ? "Cover stories, CD specials, and editorial inserts published by prominent classical music magazines."
            : "Copertine, numeri speciali e inserti dedicati all'Orchestra Busoni dalle più celebri riviste musicali (Amadeus, Suonare News)."}
        </p>
      </div>

      <div className="magazines-grid">
        {magazines.map((magazine) => (
          <Card
            key={magazine.id}
            id={magazine.id}
            title={magazine.title}
            img={magazine.img}
            details={magazine.details}
            img_width={100}
            renderBody={renderBody}
          />
        ))}
      </div>
    </div>
  );
};

export default Magazines;
